import { MouseEventHandler, ReactElement, useState } from 'react'

import { useReactiveVar } from '@apollo/client'
import classNames from 'classnames'

import { MissionRewardSelectMethodType } from '@web/gql/graphql'
import { QAModeVar } from '@web/hooks/useGlobalQAMode'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'

import Apply from './elements/Apply'
import CompletedStamp, { WinnerStamp } from './elements/CompletedStamp'
import Reward from './elements/Reward'
import Title from './elements/Title'
import { MissionCardProps } from './MissionCard'
import styles from './MissionCard.module.scss'
import QAMissionCard from './QAMissionCard'

export interface CompletedMissionCardProps {
  type?: string
  id?: string
  missionCard: MissionCardProps
  foldable?: boolean
  Content: ReactElement
  step?: number
  nClickArea?: {
    openMore: string
    closeMore: string
  }
}

const CompletedMissionCard = ({
  type,
  id,
  missionCard,
  step,
  foldable = true,
  Content,
  nClickArea,
}: CompletedMissionCardProps) => {
  const { name, label, reward } = missionCard

  const [folded, setFolded] = useState(foldable)
  const QAMode = useReactiveVar(QAModeVar)

  const toggleFold: MouseEventHandler<HTMLButtonElement> = e => {
    if (folded && nClickArea?.openMore) {
      sendClickLog({ event: e, area: nClickArea.openMore })
    }

    if (!folded && nClickArea?.closeMore) {
      sendClickLog({ event: e, area: nClickArea.closeMore })
    }

    setFolded(!folded)
  }

  const isWin =
    [
      MissionRewardSelectMethodType.Pick,
      MissionRewardSelectMethodType.Random,
      MissionRewardSelectMethodType.RandomWithBenefit,
    ].includes(reward.selectMethod) && missionCard.isRewarded

  return (
    <div
      id={id}
      className={classNames(styles.mission_card, styles.type_complete, {
        [styles.type_profile_border]: type === 'profile_border',
      })}
    >
      {/* 미션 제목 */}
      <Title
        title={name}
        emojiUrl={missionCard.iconUrl}
        label={label}
        foldable={foldable}
        onClick={toggleFold}
        folded={folded}
      />
      {/* 응모 완료 */}
      <Apply missionCard={missionCard} />
      {!folded && (
        <>
          {/* 미션 내용 */}
          {QAMode ? <QAMissionCard missionCard={missionCard} /> : Content}
          {/* 미션 보상 */}
          <Reward step={step} {...reward} />
        </>
      )}
      {/* 미션 완료 스탬프 */}
      {isWin ? <WinnerStamp /> : <CompletedStamp />}
    </div>
  )
}

export default CompletedMissionCard
